<template>
    <v-row no-gutters>

        <v-col cols="12" xs="12" md="12">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :item-class="itemRowBackground"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
                @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'CitizenStatements.EuolStatement' })">
                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                <template v-slot:[`item.createdate`]="{ item }">
                    <div>{{dateFormat(item.createdate, 'DD.MM.YYYY HH:mm:ss')}}</div>
                </template>

                <template v-slot:[`item.declarant`]="{ item }">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.declarant">
                            {{item.declarant}}
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.annotation`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <v-chip
                            v-if="item.ordernumber > 0"
                            class="table-label sendedstatus"                            
                            small
                            label                            
                            :outlined="!item.sendedtoaikyn"
                            :color="item.sendedtoaikyn ? 'var(--d-green)' : '' "   
                            :text-color="item.sendedtoaikyn ? 'white' : ''"
                        >
                            <div>{{$t("Версия")}} {{item.ordernumber}}</div>
                        </v-chip>
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.annotation">
                                {{item.annotation}}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.controldate`]="{ item }">
                    <div>{{dateFormat(item.controldate, 'DD.MM.YYYY')}}</div>
                </template>
                
                <template v-slot:[`item.answerstatus`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <StatusChip :status="getEuolExecutionStatus(item)"/>
                        <StatusChip :status="getEuolAnswerStatus(item)"/>
                    </div>
                </template>

                <template v-slot:footer.prepend>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
        </v-col>

    </v-row>
</template>

<script>
import i18n from '@/i18n'
import Axios from "axios";
import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system"
import StatusChip from "@/components/StatusChip"

export default {
    columnIndex:  {
        'regnumber': 2,
        'regdate': 3,
        'declarant': 6,
        'annotation': 14,
        'uniquenumber': 4,
        'controldate': 5,
        'answerstatus': 9,
        'createdate': 17
    },
    components:{
        StatusChip
    },
    props: {
        status: {
            type: String,
            default: null
        },
        search: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            loading: true,
            cancellationTokenSorce: null,
            headers: [
                { text: i18n.t("Дата_поступления"), value: 'createdate', width: '150px' },
                { text: i18n.t("Рег._№"), value: 'regnumber', width: '150px' },
                { text: i18n.t("Обратившееся_лицо") , value: 'declarant' },
                { text: i18n.t("Краткое_содержание"), value: 'annotation' },
                { text: i18n.t("Уникальный_номер"), value: 'uniquenumber' },
                { text: i18n.t("Срок"), value: 'controldate', width: '110px' },
                { text: i18n.t("Статус"), value: 'answerstatus', sortable: false },
            ],
            total: 0,            
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,
        }
    },
    computed: {
        options: {
            get: function() {
                return this.$store.getters['chancellary/statement/GetTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('chancellary/statement/SET_TABLE_OPTION', newValue);
            }
        },
        extendedTableFilter: {
            get: function() {
                var extendedFilters = this.$store.getters['chancellary/getExtendedFilters'];
                if (!extendedFilters) return {};
                
                var result =  extendedFilters.find(x => x.collection == this.collection)?.value ?? {};
                return result;
            }
        },
        collection() {
            return this.$store.getters['chancellary/getCollection'];
        },
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                RegState: this.status,
                extendedFilterData: this.$helpers.getOnlySelectedParams(this.extendedTableFilter)
            }
        },
        avaibleStatuses() {
            return this.$store.getters['references/GetAvaibleStatuses'];
        },
    },
    methods: {
        resetPage() {
            this.$store.commit('chancellary/statement/SET_TABLE_OPTION_PAGE', 1);
        },
        getEuolAnswerStatus(source) {            
            var key = this.$helpers.getEuolAnswerStatus(source);
            return this.avaibleStatuses[key];
        },
        getEuolExecutionStatus(source) {
            var key = this.$helpers.getEuolExecutionStatus(source, this.currentTimestamp);
            return this.avaibleStatuses[key];
        },
        itemRowBackground (item) {
            return item.readed ? '' : 'font-weight-bold';
        },        
        async getData(isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
                
            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;
            this.$emit("change_loaddata_status",this.loading);
            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();

            let response = await httpAPI({
                url: `/api/chancellary/statementslist?filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });

            this.currentTimestamp = response?.data?.payload?.currentTimestamp ?? Date.now();
            this.entities = response?.data?.payload?.data ?? [];
            this.total = response?.data?.payload?.total ?? 0;
            this.loading = false;
            this.$emit("change_loaddata_status",this.loading);
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, RegState, extendedFilterData } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? true : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "createdate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 17;
            return { SearchStr, RegState, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, ...extendedFilterData };
        },
        dateFormat: sys.dateFormat,
    },
    watch: {
        filter: {
            handler() {
                this.getData()
            },
            deep: true,
        },
    },
}
</script>
